import { IPowerBIApiService, PowerBIApiService } from 'api/services/powerbi-api-service';
import { IServiceFactory } from '../../common/types/service-factory';
import { ApiServiceFactoryBase } from './base/api-service-factory-base';

export class PowerBiApiServiceFactory extends ApiServiceFactoryBase implements IServiceFactory<IPowerBIApiService> {
	public Create(): IPowerBIApiService {
		return new PowerBIApiService(this.apiServiceFactory.Create(), this.appConfigService);
	}
}
